import React from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';
import { ACTION_TYPES } from '../../../services/auditLogService';

const ACTION_TYPE_OPTIONS = [
  { value: '', label: 'All Actions' },
  ...Object.values(ACTION_TYPES)?.map(v => ({ value: v, label: v }))
];

const AuditFilters = ({ filters, onFilterChange, admins, onReset }) => {
  const adminOptions = [
    { value: '', label: 'All Admins' },
    ...admins?.map(a => ({ value: a?.id, label: a?.full_name || a?.email }))
  ];

  return (
    <div className="bg-card border border-border rounded-xl p-4 space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-semibold text-foreground flex items-center gap-2">
          <Icon name="Filter" size={16} className="text-accent" />
          Filters
        </h3>
        <Button variant="ghost" size="sm" onClick={onReset}>
          <Icon name="RotateCcw" size={14} className="mr-1" />
          Reset
        </Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-3">
        <div>
          <label className="block text-xs font-medium text-muted-foreground mb-1">Date From</label>
          <Input
            type="date"
            value={filters?.dateFrom}
            onChange={(e) => onFilterChange('dateFrom', e?.target?.value)}
          />
        </div>
        <div>
          <label className="block text-xs font-medium text-muted-foreground mb-1">Date To</label>
          <Input
            type="date"
            value={filters?.dateTo}
            onChange={(e) => onFilterChange('dateTo', e?.target?.value)}
          />
        </div>
        <Select
          label="Action Type"
          options={ACTION_TYPE_OPTIONS}
          value={filters?.actionType}
          onChange={(v) => onFilterChange('actionType', v)}
        />
        <Select
          label="Administrator"
          options={adminOptions}
          value={filters?.adminId}
          onChange={(v) => onFilterChange('adminId', v)}
        />
        <div>
          <label className="block text-xs font-medium text-muted-foreground mb-1">Affected User</label>
          <Input
            type="text"
            placeholder="Search by email..."
            value={filters?.affectedUserSearch}
            onChange={(e) => onFilterChange('affectedUserSearch', e?.target?.value)}
          />
        </div>
      </div>
    </div>
  );
};

export default AuditFilters;
